export const API_BASE_URL_OPTIONS = {
  local: 'http://localhost:8006',
  staging: 'https://staging.feathery.io',
  production: 'https://api.feathery.io',
  productionAU: 'https://api-au.feathery.io',
  productionEU: 'https://api-eu.feathery.io',
  productionCA: 'https://api-ca.feathery.io'
};

let environment: keyof typeof API_BASE_URL_OPTIONS = 'production';
if (window.location.host === 'au.document.feathery.io')
  environment = 'productionAU';
else if (window.location.host === 'eu.document.feathery.io')
  environment = 'productionEU';
else if (window.location.host === 'ca.document.feathery.io')
  environment = 'productionCA';

const BASE_URL = API_BASE_URL_OPTIONS[environment];

export const request = async (endpoint: string, options: RequestInit = {}) => {
  return fetch(`${BASE_URL}${endpoint}`, options).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('Something went wrong');
    }
  });
};
